export const PostAmountText = ({ posts }) => {
  return (
    <p className="text-sm text-muted-foreground" data-testid="post-amount-text">
      {posts.length === 0 ? 'Nenhum conteúdo' : posts.length === 1 ? '1 conteúdo' : `${posts.length} conteúdo(s)`}
    </p>
  )
}
